import  './css/UsuariosLista.css';
import axios from 'axios';
import { Link, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { show_alerta } from '../../funciones.js';
import { useNavigate } from "react-router-dom";


import UsuarioRoles  from "./UsuarioRoles";
import UsuarioCrudForm from './UsuarioCrudForm.js';
import Roles from './Roles.js';
import CONFIG from '../../config.js';
import UsuarioBotoneraPermitida from './UsuarioBotoneraPermitida.js';

const URL_LISTAR = `${CONFIG.API_URL}/listarUsuarios.php`;
const URL  = `${CONFIG.API_URL}/operarTablaUsuario.php`;

function UsuariosLista({acceder, rol, rolSelect}){
    const navigate = useNavigate();
    const rolRegistrado = localStorage.getItem('loggeduserRolId');
    const [buscar, setBuscar] = useState("");
    const [usuarios, setUsuarios] = useState([]);
    const [roles, setRoles] = useState({});

    const location = useLocation();
    const { userId } = useParams();

    //  inspeccionar el pathname para ver si llao la ruta cuotas
    const esRutaCuotas = location.pathname.includes("/Usuarios/Cuotas/");
    
    const [datoAEditar, setDatoAEditar] = useState(null);
    const [idUsuario, setIdUsuario] = useState(0);

    useEffect(()=>{
        if(acceder){
            if((rol===null)||((rol>4) && (rol<13))){
                navigate("/");
            }
          //  if(((rol>=13) || (rolRegistrado>=13)) && (userId==0)){
           //    navigate("/");
           // }
            buscarRoles(rol);
        }else{
            localStorage.clear();
            rolSelect(null)
            navigate('/');
        }
    },[ rol])

    const buscarRoles = (rol) =>{
        const dataR= { rol: userId, modo:'buscarRoles' }
        axios.post(URL_LISTAR, dataR)
        .then(res =>{  
            if(!res.data.error){ 
                setRoles(res.data);
                console.log('roles:',res.data);
            }else{
                setRoles([]);
            }
        })
        .catch(err=>{  
            console.log(err);
        })
    }

    const crearData = (data) =>{
        enviarSolicitud("POST", data);
    };

    const actualizarData = (data) =>{
        console.log(data);
        enviarSolicitud("PUT", data);
    };

    const eliminarData = (id) =>{
        const MySwal= withReactContent(Swal); 
        MySwal.fire({
            title: '¿Seguro de eliminar el usuario?',
            icon: 'question', 
            text: 'No se podrá dar marcha atrás',
            showCancelButton: true, confirmButtonText: 'Si, eliminar', cancelButtonText: 'Cancelar'
        })
        .then(res=>{
            if(res.isConfirmed){
                enviarSolicitud('DELETE',{'id':id})
            }
            else{
                show_alerta('El usuario NO fue eliminado');
            }
        });
    };

    const data= {
        'id_rol' :  userId,
        'modo'  :'buscaUsuariosPorRol'
    }

    useEffect( ()=>{
        axios.post(URL_LISTAR, data)
        .then(res =>{
            if(!res.data.error){ 
                setUsuarios(res.data);
            }else{
                setUsuarios([]);
            }
        })
        .catch(err=>{
            console.log(err);
        })
        resultado= usuarios;
    },[usuarios])

    const handleBuscar = (e) => {
        setBuscar(e.target.value)
       // console.log(e.target.value)
    }

    //metodo de filtrado
    let resultado=[];
    if(!buscar){
        resultado= usuarios;
    }else{
        resultado= usuarios.filter((dato)=>{
            if( (dato.nombre.toLowerCase().includes(buscar.toLocaleLowerCase())) || 
                (dato.apellido.toLowerCase().includes(buscar.toLocaleLowerCase())) ||
                (dato.usuario.toLowerCase().includes(buscar.toLocaleLowerCase())) ||
                (dato.documento.toString().toLowerCase().includes(buscar.toLocaleLowerCase())) ){
                return true;
            }
            return false;
        });
    }

    //constantes para paginacion
    const [paginaActual, setPaginaActual]=useState(1);
    const registrosPorPagina=10;
    const ultimoIndice = paginaActual * registrosPorPagina;
    const primerIndice = ultimoIndice - registrosPorPagina;
    const registros = resultado.slice(primerIndice, ultimoIndice);
    const npaginas =Math.ceil(resultado.length / registrosPorPagina);
   
    const enviarSolicitud = async (metodo, parametros) =>{
        await axios({method:metodo, url:URL, data:parametros})
            .then(res =>{
                var tipo = res.data[0];
                var msj = res.data[1];
              //  console.log(msj+'-'+tipo);
                show_alerta(msj,tipo);
                if(tipo==='success'){
                    document.getElementById('btnCerrar').click();
                }
            })
            .catch(err=>{
                show_alerta('Error en la solicitud ','error');
                console.log(err);
            })
    }

    const resetPassword = async (id) =>{
        await axios({method:'PUT', url:URL, data:{id:id, modo:'resetPassword'}})
            .then(res =>{
                var tipo = res.data[0];
                var msj = res.data[1];
                show_alerta(msj,tipo);
            }   
            )
            .catch(err=>{
                show_alerta('Error en la solicitud ','error');
                console.log(err);
            })
    }


    return(
        <div className='container-principal'>    
            <h4>
               {!esRutaCuotas && <Link className='btn btn-sm btn-outline-secondary me-2 mb-2' to={'/usuarios'}> <i className="fa-solid fa-backward"></i></Link> }
                {userId >0 && `${roles.nombre}`} {userId==-1 && ` Sin rol asignado`}
            </h4>
            { userId == 0 ? (<button type="button" className='btn btn-outline-success me-2 mb-1' onClick={()=>setDatoAEditar(null)}  data-bs-toggle="modal" data-bs-target="#modalEditar" ><i className="fa-solid fa-circle-plus"></i> nuevo usuario</button>) : ''}
            <div className="input-group mb-3 me-2">
                    <span className="input-group-text" id="basic-addon1"><i className="fa-solid fa-magnifying-glass"></i></span>
                    <input type="text" className="form-control" id='buscar' name='buscar' defaultValue={buscar} onChange={handleBuscar} placeholder='buscar...' aria-label='buscar' aria-describedby='basic-addon1' />
            </div>
            <small>filtro <b>{resultado.length} / {usuarios.length}</b> </small>  
            {rol==13 && esRutaCuotas && 
                <div>
                    <button type='button' className='btn btn-danger mx-1'> cuota adeudadas</button>
                    <button type='button' className='btn btn-info'> todos</button>
                </div> 
            }
            <table className='table table-sm table-striped table-hover mt-2 shadow-lg'>
            <thead className='bg-cabecera-tabla small'>
                    <tr>
                        <th>Apellido</th>
                        <th>Nombre</th>
                        <th>Nom. usuario</th>
                        <th>Documento</th>
                        { userId == 0 ? (<th>rol/es</th>) : ''}
                        <td>ficha</td>
                        { ((userId == 0)&&(rol!=13)) ? (<th>acc.</th>) : ''}
                        { (userId == 7) && (rol!=13) ? (<th>acc.</th>) : ''}
                    </tr>
            </thead>
            <tbody className='small'>
            { !!registros && 
                    registros.map(u => (
                        <tr key={u.id}>
                            <td>{u.apellido}</td>
                            <td>{u.nombre}</td>
                            <td>{u.usuario}</td>
                            <td>{u.documento}</td>
                            { userId == 0 ? (<td><UsuarioRoles id_usuario={u.id} rol={rol} /></td>) : ''} 
                            <td>
                                <button type="button" className='btn btn-sm btn-info' onClick={()=> navigate(`/Ficha/${u.id}`)} ><i className="fa-regular fa-id-card"></i></button>
                                {esRutaCuotas && <button type="button" className='btn btn-sm btn-outline-secondary mx-1'><i className="fa-solid fa-money-bill-1-wave text-success"></i> Ver cuotas</button>}
                            </td>
                            { ((userId == 0)&&(rol!=13)) ? (
                            <td>
                                <button type="button" className='btn btn-sm btn-primary me-1' onClick={()=>setIdUsuario(u.id)} data-bs-toggle="modal" data-bs-target="#modalRoles"><i className='fa-solid fa-circle-plus'></i> rol</button>
                                
                                <UsuarioBotoneraPermitida 
                                rolLogeado={rol} 
                                usr={u}
                                setIdUsuario={setIdUsuario}
                                setDatoAEditar={setDatoAEditar}
                                eliminarData={eliminarData} />
                                </td>
                            ) : ''}
                            
                        </tr>
                    ))}
            </tbody>
            </table>
            <nav>
                <ul className='pagination'>
                    <li className='page-item'>
                        <a href='#' className='page-link' onClick={prePage}>Prev</a>
                    </li>
                    
                    <li className='page-item'>
                        <a href='#' className='page-link' onClick={nexPage}>Prox </a>
                    </li>
                </ul>
            </nav>

            {/* Modal para crear o editar usuario */}
            <div id="modalEditar" className="modal fade" aria-labelledby="modalUsuarios" aria-hidden="true">
                <div className='modal-dialog'>
                    <div className="modal-content">
                        <div className='modal-header'>
                            <h1 className="modal-title fs-5" id="ModalLabel"></h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className='modal-body'>
                           
                            <UsuarioCrudForm crearData={crearData} actualizarData={actualizarData} datoAEditar={datoAEditar} setDatoAEditar={setDatoAEditar} />
                           
                        </div>
                        <div className="modal-footer">
                            <button type="button" id='btnCerrar' className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal para asignar roles */}
            <div id="modalRoles" className="modal fade" aria-labelledby="modalUsuarios" aria-hidden="true">
                <div className='modal-dialog'>
                    <div className="modal-content">
                        <div className='modal-header'>
                            <h1 className="modal-title fs-5" id="ModalLabel">Roles Disponibles</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className='modal-body'>
                            <Roles idUsuario={idUsuario} setUsuarios={setUsuarios} rol={rol} />
                        </div>
                        <div className="modal-footer">
                            <button type="button" id='btnCerrar2' className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Modal para resetear contraseña */}
            <div id="modalResetPassword" className="modal fade" aria-labelledby="modalResetPassword" aria-hidden="true">
                <div className='modal-dialog'>
                    <div className="modal-content">
                        <div className='modal-header'>
                            <h1 className="modal-title fs-5" id="ModalLabel"> <i className="fa-solid fa-key"></i> Resetear Contraseña</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className='modal-body'>
                            <h5>¿Desea resetear la contraseña del usuario?</h5>
                            <p>La nueva contraseña será 123. Se recomienda cambiarla después de iniciar sesión.</p>
                            <button type="button" className='btn btn-sm btn-warning me-1' onClick={()=>resetPassword(idUsuario)} data-bs-toggle="modal" data-bs-target="#modalResetPassword"><i className="fa-solid fa-key"></i> Resetear</button>
                        </div>
                        <div className="modal-footer">
                            <button type="button" id='btnCerrar2' className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
    function prePage(){
        if(paginaActual !== 1){
            setPaginaActual(paginaActual - 1);
        }
    }
    function nexPage(){
        if(paginaActual !== npaginas){
            setPaginaActual(paginaActual + 1);
        }    
    }
    
}


export default UsuariosLista;